"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMap = toMap;
function toMap(objects, keyFunc, transform = (o) => o) {
    const m = {};
    objects.forEach((o) => (m[keyFunc(o)] = transform(o)));
    return m;
}
//# sourceMappingURL=ObjMap.js.map